import i18next from 'i18next';
import { CabinType, LoginType, TierType, UserTitlesType } from 'models/types';

export const CabinClass: { value: CabinType; title: string }[] = [
  { title: i18next.t('constants.cabinClass.business'), value: 'business' },
  { title: i18next.t('constants.cabinClass.economy'), value: 'economy' },
];

export const TierStatus: { value: TierType; title: string }[] = [
  { title: i18next.t('constants.tierStatus.silver'), value: 'Silver' },
  { title: i18next.t('constants.tierStatus.gold'), value: 'Gold' },
  { title: i18next.t('constants.tierStatus.vip'), value: 'VIP' },
];

export const userTitle: { value: string; title: UserTitlesType }[] = [
  { title: i18next.t('constants.personTitles.mr'), value: 'Mr' },
  { title: i18next.t('constants.personTitles.miss'), value: 'Miss' },
  { title: i18next.t('constants.personTitles.ms'), value: 'Ms' },
  { title: i18next.t('constants.personTitles.mrs'), value: 'Mrs' },
];

export const loginType: { value: LoginType; name: string }[] = [
  { name: i18next.t('constants.loginTypes.email'), value: 'email' },
  { name: i18next.t('constants.loginTypes.idNumber'), value: 'idNumber' },
];
